export default __webpack_public_path__ + "static/media/amenaza_parto_prematuro.1007207f.pdf";